/* eslint-disable unicorn/prefer-dom-node-append */
/* eslint-disable unicorn/prevent-abbreviations */
/* eslint-disable unicorn/prefer-global-this */
/* eslint-disable func-style */
import type { HotjarFunction } from "~/lib/hotjar";
import { tagRecording } from "~/utils/hotjarTracking";
import useTrackingConsent from "../composables/useTrackingConsent";

// eslint-disable-next-line no-restricted-exports
export default defineNuxtPlugin({
    name: "hotjar",
    setup() {
        const config = useRuntimeConfig();

        const siteId = config.public.hotjarSiteId;

        if (!siteId || !config.public.hotjarTrackingActive) return;

        const { isAccepted } = useTrackingConsent();

        const { slug } = storeToRefs(useSlugStore());

        let hotjarInitialized = false;

        const initHotjar = () => {
            if (window.hj ?? hotjarInitialized) return;

            const hjFunc: HotjarFunction = (...args) => {
                hjFunc.q = hjFunc.q ?? [];
                hjFunc.q.push(args);
            };

            window.hj = hjFunc;
            window._hjSettings = { hjid: siteId };

            const script = document.createElement("script");
            script.async = true;
            script.src = `https://static.hj.contentsquare.net/c/csq-${siteId}.js`;
            document.head.appendChild(script);

            hotjarInitialized = true;

            // Tagging the recording with the slug
            tagRecording(["slug-" + (slug.value ?? "*")]);
        };

        watchEffect(() => {
            if (!isAccepted.value) return;

            initHotjar();
        });
    },
});
